import { ContentPreviewer } from '@shared/components';
import { useCallback, useEffect, useState } from 'react';

import { useParseContentForSingleQuestionCreation } from '../../hooks';

function useParseQuestionContent(content: string, questionId: string, taskId: string) {
  const { parseSingleQuestionContent } = useParseContentForSingleQuestionCreation({
    questionId,
    taskId,
  });
  const [parsedContent, setParsedContent] = useState('');

  const handleParsedImage = useCallback(async () => {
    if (!content) return;

    const parsedContent = await parseSingleQuestionContent(content);

    setParsedContent(parsedContent);
  }, [content, parseSingleQuestionContent]);

  useEffect(() => {
    handleParsedImage();
  }, [handleParsedImage]);

  return {
    content: parsedContent,
  };
}

interface QuestionContentPreviewerProps {
  content: string;
  questionId: string;
  taskId: string;
}

export default function QuestionContentPreviewer(props: Readonly<QuestionContentPreviewerProps>) {
  const { content, questionId, taskId } = props;
  const { content: parsedContent } = useParseQuestionContent(content, questionId, taskId);

  return <ContentPreviewer content={parsedContent} />;
}
